<template>
    <ValidationProvider tag="div"
                        class="form-group field-checkbox"
                        :class="{ required: isRequired }"
                        :rules="rules"
                        :immediate="!!value"
                        v-slot="{ classes, errors }">
        <div v-if="errors[0]" class="invalid-feedback">{{ errors[0] }}</div>
        <label v-if="fieldLabel">{{ fieldLabel }}</label>
        <div class="custom-control"
             :class="{
                'custom-checkbox': (!isSwitch && !isBigSwitch),
                'custom-switch': (isSwitch || isBigSwitch),
                'big-switch': isBigSwitch, ...classes
            }">
            <input type="checkbox"
                   :id="'checkbox-' + _uid"
                   class="custom-control-input custom-style"
                   :name="'checkbox-' + _uid"
                   :value="value"
                   :true-value="trueValue"
                   :false-value="falseValue"
                   :checked="isChecked"
                   :required="required"
                   :disabled="disabled"
                   @change="handleChange">
            <label v-if="label" class="custom-control-label" :for="'checkbox-' + _uid">{{ label }}</label>
        </div>
    </ValidationProvider>
</template>

<script>
import BaseField from './BaseField'

export default {
    name: 'Checkbox',
    extends: BaseField,
    model: {
        event: 'change'
    },
    props: {
        fieldLabel: {
            type: String
        },
        label: {
            type: String
        },
        switch: {
            type: Boolean,
            default: false
        },
        bigSwitch: {
            type: Boolean,
            default: false
        },
        trueValue: {
            default: true
        },
        falseValue: {
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isSwitch() {
            return (this.switch)
        },
        isBigSwitch() {
            return (this.bigSwitch)
        },
        isChecked() {
            return (this.value === this.trueValue)
        }
    },
    methods: {
        handleChange(event) {
            this.$emit('change', (event.target.checked) ? this.trueValue : this.falseValue)
        }
    }
}
</script>
